/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiUserColumnsResponse
 */
export interface ApiUserColumnsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiUserColumnsResponse
     */
    columns: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiUserColumnsResponse
     */
    etc?: Array<string> | null;
}

export function ApiUserColumnsResponseFromJSON(json: any): ApiUserColumnsResponse {
    return ApiUserColumnsResponseFromJSONTyped(json, false);
}

export function ApiUserColumnsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserColumnsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columns': json['columns'],
        'etc': !exists(json, 'etc') ? undefined : json['etc'],
    };
}

export function ApiUserColumnsResponseToJSON(value?: ApiUserColumnsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columns': value.columns,
        'etc': value.etc,
    };
}

